<div
  class="flex h-full flex-col gap-5 overflow-hidden rounded transition-transform duration-100 active:scale-105"
  [style.backgroundColor]="cardColor() | contentBuilderColor: '#ffffff'"
  [style.color]="textColor() | contentBuilderColor"
  [class.cursor-pointer]="isProductAvailable()"
  [class.pointer-events-none]="!isProductAvailable()"
  (click)="!isProductAvailable() ? null : addToCart()"
>
  <div class="relative flex h-full flex-col justify-between gap-5 pb-4">
    @let showProductInfoIcon =
      isShowProductIcon() && !!(product().description?.length || product().allergens?.length);
    <div class="m-auto flex max-w-44 flex-col pb-8">
      <div class="my-2 flex w-full items-end">
        @if (showProductInfoIcon) {
          <span
            class="w-[1.875rem] shrink-0"
            aria-hidden="true"
          ></span>
        }
        <p
          class="min-w-0 flex-1 line-clamp-2 h-12 content-end overflow-hidden text-center align-bottom font-accent text-base font-bold"
          [class.px-1]="!showProductInfoIcon"
        >
          {{ product()[ProductKeys.Name] }}
        </p>
        @if (showProductInfoIcon) {
          <i
            (click)="!isProductAvailable() ? null : showProductModal(); $event?.stopPropagation?.()"
            class="icon icon-c-info-3 pointer-events-auto inline-flex h-5 w-5 shrink-0 items-center justify-center text-xl font-semibold"
            [style.color]="textColor() | contentBuilderColor"
            [class.opacity-50]="!isProductAvailable()"
          ></i>
          <span
            class="w-2.5 shrink-0"
            aria-hidden="true"
          ></span>
        }
      </div>

      <div class="relative m-auto aspect-square h-44 w-44 rounded">
        @if (quantity()) {
          <div
            class="absolute left-2 top-2 z-40 flex h-6 w-6 items-center justify-center rounded-full bg-neutral-300 text-center text-sm font-bold"
          >
            {{ quantity() }}
          </div>
        }
        <!-- Gradient Background -->
        <div
          class="absolute inset-0 h-44 w-44 rounded"
          [appRadialGradient]="product()[ProductKeys.Images]?.thumbnail?.colors"
        ></div>

        <!-- Product Image -->
        @if (product().images?.thumbnail?.url) {
          <img
            class="relative z-10 h-44 w-44 rounded object-cover"
            [src]="product().images?.thumbnail?.url"
            [alt]="product[ProductKeys.Name]"
          />

          @let visibleLabels = product().labels | appVisibleLabels;
          @if (visibleLabels?.length) {
            <ul class="mt-6 flex flex-wrap justify-center gap-1 mb-4">
              @for (label of visibleLabels; track label) {
                <li>
                  <app-tag-atom
                    [bold]="false"
                    [text]="label.name"
                    color="highlight"
                    [color]="$any(label.color) ?? 'highlight'"
                  ></app-tag-atom>
                </li>
              }
            </ul>
          }
        }
      </div>
      <div class="relative z-40 flex flex-col flex-wrap backdrop-grayscale">
        <div class="absolute -bottom-5 flex w-full justify-center text-center">
          <div
            class="w-fit px-2 py-1 rounded-sm"
            [style.backgroundColor]="cardColor() | contentBuilderColor: 'white'"
          >
            @if (product()[ProductKeys.PriceToDisplay]) {
              <app-price-atom
                class="mr-1"
                size="2XL"
                [priceColor]="priceColor()"
                [amount]="$any(product()[ProductKeys.PriceToDisplay])"
                [discount]="_hasDiscountPromotionLabel()"
                [semiBold]="true"
              ></app-price-atom>
            } @else if (displayDiscount()) {
              <app-price-atom
                size="2XL"
                class="mr-1"
                [amount]="product()[ProductKeys.Discount] ?? 0"
                [priceColor]="priceColor()"
                [semiBold]="true"
                [whiteOutline]="true"
              ></app-price-atom>
              <app-price-atom
                class="mr-1"
                size="2XL"
                [amount]="product()[ProductKeys.Price]"
                [priceColor]="priceColor()"
                [discount]="true"
                [semiBold]="true"
                [whiteOutline]="true"
              ></app-price-atom>
            } @else {
              <app-price-atom
                class="mr-1"
                size="2XL"
                [priceColor]="priceColor()"
                [amount]="product()[ProductKeys.Price]"
                [discount]="_hasDiscountPromotionLabel()"
                [semiBold]="true"
                [whiteOutline]="true"
              ></app-price-atom>
            }
          </div>
        </div>
      </div>
    </div>
    @if (!isProductAvailable()) {
      <div class="absolute flex h-full w-full flex-row flex-wrap items-center justify-center gap-5">
        <div class="z-30">
          @if (!isProductAvailable()) {
            <app-button-atom
              size="S"
              [label]="'_.UNAVAILABLE' | translate"
              thickSize="XS"
              [overrideBgColor]="unavailableButtonBackground()"
              [overrideTextColor]="unavailableButtonText()"
              type="kiosk-primary"
              [full]="true"
            ></app-button-atom>
          }
        </div>
        <div
          class="pointer-events-none absolute h-full w-full opacity-80 unavailable-background"
          [class.bg-neutral-400]="!isProductAvailable()"
        ></div>
      </div>
    }
  </div>
</div>
